import { resolveMediaUrl } from "@/components/FileUpload";

export function UserAvatar({ src, name = "?", color = "#2563EB", className = "h-8 w-8", textClass = "text-xs" }) {
  if (src) {
    return (
      <img
        src={resolveMediaUrl(src)}
        alt={name}
        className={`${className} rounded-full object-cover shrink-0`}
      />
    );
  }
  const initials = name.split(" ").map((p) => p[0]).slice(0, 2).join("");
  return (
    <span
      className={`${className} rounded-full text-white ${textClass} font-bold flex items-center justify-center shrink-0`}
      style={{ background: color }}
    >
      {initials}
    </span>
  );
}
